<template>
	<div id="main" class="column is-9">
		<ProfileHeader :psychic="psychic" />
		<LoginHistory :id="this.$route.params['id']" />
	</div>
</template>

<script>
	import ProfileHeader from "./ProfileHeader.vue"
	import LoginHistory from "../shared/LoginHistory.vue"

	export default {
		components: {
			ProfileHeader,
			LoginHistory,
		},
		data() {
			return {
				psychic: {},
			}
		},
		async created() {
			this.psychic = await this.$root.$data.getters.getPsychic(this.$root.$data.state, this.$route.params["id"])
		}
	}
</script>